import { s as S, c as m, a as o, b as u, e as n, f as E } from "./vendor-DxSylgwR.js";
var l = /* @__PURE__ */ ((r) => (r.FETCH_AVAILABILITIES_FAILED = "FETCH_AVAILABILITIES_FAILED", r.INVALID_SLOT = "INVALID_SLOT", r.INVALID_PROVIDER = "INVALID_PROVIDER", r.INVALID_LOCATION = "INVALID_LOCATION", r.ADD_TO_CART_FAILED = "ADD_TO_CART_FAILED", r.FETCH_AMOUNT_FAILED = "FETCH_AMOUNT_FAILED", r.GENERAL_ERROR = "GENERAL_ERROR", r))(l || {});
class c extends Error {
  constructor(t, e, i) {
    super(t), this.code = e, this.details = i, this.name = "ReservationError";
  }
}
var s = /* @__PURE__ */ ((r) => (r.AMOUNTS_UPDATED = "amountsUpdated", r.AVAILABILITIES_UPDATED = "availabilitiesUpdated", r.SLOT_SELECTED = "slotSelected", r.RESERVATION_READY = "reservationReady", r.CUSTOM_FIELDS_UPDATED = "customFieldsUpdated", r.PROVIDERS_UPDATED = "providersUpdated", r.MONTH_CHANGED = "monthChanged", r.CUSTOMER_LOCATION_UPDATED = "customerLocationUpdated", r.ERROR = "error", r))(s || {});
const A = 5;
function p(r, t, e) {
  return {
    product: r,
    priceId: t || r.pricing[0]?.id,
    amount: {
      effectiveQuantity: 1,
      totalAfterDiscount: r.discountedAmount,
      totalPrice: r.amount
    },
    availabilities: {
      isLocationApplicable: !1,
      slots: []
    },
    displayYear: (/* @__PURE__ */ new Date()).getFullYear(),
    displayMonth: (/* @__PURE__ */ new Date()).getMonth(),
    displayDay: void 0,
    selectedSlot: void 0,
    quantity: 1,
    addOns: void 0,
    selectedProviderCount: 1,
    selectedProviderIds: r.enableCustomerToChooseProvider ? [r.productProviders[0].id] : void 0,
    customFields: void 0,
    filterMaxSelectableTo: void 0,
    filterFrom: void 0,
    customerLocation: e,
    error: void 0,
    errorRetries: 0
  };
}
const h = (r) => S({
  actors: {
    fetchAvailabilities: E(async ({ input: t }) => {
      const { context: e } = t;
      try {
        var i = new Date(
          e.displayYear,
          e.displayMonth,
          1
        );
        e.filterFrom !== void 0 && e.filterFrom < i && (i = e.filterFrom);
        var a = new Date(
          e.displayYear,
          e.displayMonth + 1,
          0
        );
        return e.filterFrom !== void 0 && e.filterFrom > a && (a = e.filterFrom), await r.getAvailablities(
          e.priceId,
          i,
          a,
          {
            quantity: e.quantity,
            productProvidersIds: e.selectedProviderIds,
            productProviderCount: e.selectedProviderCount,
            location: e.customerLocation
          }
        );
      } catch (d) {
        throw console.error(d), new c(
          "Failed to fetch availabilities",
          l.FETCH_AVAILABILITIES_FAILED,
          { error: d }
        );
      }
    }),
    updateAmounts: E(
      async ({ input: t }) => {
        const { context: e } = t;
        try {
          const i = e.availabilities[0];
          if (!e.selectedSlot && !i) {
            const a = e.product.pricing.find(
              (d) => d.id === e.priceId
            );
            return {
              totalPrice: a?.amount ?? e.product.amount,
              totalAfterDiscount: a?.discountedAmount ?? e.product.discountedAmount,
              effectiveQuantity: 1
            };
          }
          return await r.getReservationPriceAmount(
            e.priceId,
            e.selectedSlot?.from.toISOString() ?? i.from.toISOString(),
            e.selectedSlot?.to.toISOString() ?? i.to.toISOString(),
            e.quantity,
            {
              providersIds: e.selectedProviderIds,
              providerCount: e.selectedProviderCount,
              customFieldValues: {
                ...e.customFields,
                ...e.addOns
              }
            }
          );
        } catch (i) {
          throw new c(
            "Failed to update the price amount",
            l.FETCH_AMOUNT_FAILED,
            { error: i }
          );
        }
      }
    )
  },
  actions: {
    resetContext: o(({ context: t }) => p(t.product)),
    incrementRetries: o({
      errorRetries: ({ context: t }) => t.errorRetries + 1
    }),
    resetRetries: o({
      errorRetries: 0,
      error: void 0
    }),
    changePrice: o({
      priceId: ({ event: t }) => {
        if (t.type !== "CHANGE_PRICE")
          throw new Error("Invalid event type");
        return t.priceId;
      }
    }),
    selectSingleDate: o({
      displayYear: ({ context: t, event: e }) => {
        if (e.type !== "SELECT_SINGLE_DATE")
          throw new Error("Invalid event type");
        return e.date?.getFullYear() ?? t.displayYear;
      },
      displayMonth: ({ context: t, event: e }) => {
        if (e.type !== "SELECT_SINGLE_DATE")
          throw new Error("Invalid event type");
        return e.date?.getMonth() ?? t.displayMonth;
      },
      displayDay: ({ event: t }) => {
        if (t.type !== "SELECT_SINGLE_DATE")
          throw new Error("Invalid event type");
        return t.date?.getDate();
      },
      selectedSlot: ({ context: t, event: e }) => {
        if (e.type !== "SELECT_SINGLE_DATE")
          throw new Error("Invalid event type");
        if (e.date === void 0 || !t.product.isFullDayBooking) return;
        if (t.product.isVariableDuration)
          throw new Error(
            "Variable duration not supported in SELECT_SINGLE_DATE"
          );
        if (t.availabilities.slots.length === 0) return;
        const i = t.availabilities.slots.find(
          (a) => a.from.getDate() === e.date?.getDate() && a.from.getMonth() === e.date?.getMonth()
        );
        if (i !== void 0)
          return {
            from: i.from,
            to: i.to
          };
      }
    }),
    changeMonth: o({
      displayYear: ({ context: t, event: e }) => {
        if (e.type !== "CHANGE_MONTH")
          throw new Error("Invalid event type");
        return e.date.getFullYear() ?? t.displayYear;
      },
      displayMonth: ({ context: t, event: e }) => {
        if (e.type !== "CHANGE_MONTH")
          throw new Error("Invalid event type");
        return e.date.getMonth() ?? t.displayMonth;
      },
      displayDay: ({ context: t, event: e }) => {
        if (e.type !== "CHANGE_MONTH")
          throw new Error("Invalid event type");
        if (t.selectedSlot !== void 0)
          return e.date.getFullYear() != t.selectedSlot.from.getFullYear() || e.date.getMonth() != t.selectedSlot.from.getMonth() ? void 0 : t.selectedSlot.from.getDate();
        if (t.filterFrom !== void 0)
          return e.date.getFullYear() != t.filterFrom.getFullYear() || e.date.getMonth() != t.filterFrom.getMonth() ? void 0 : t.filterFrom.getDate();
      }
    }),
    changeProviderIds: o({
      selectedProviderIds: ({ event: t }) => {
        if (t.type !== "CHANGE_PROVIDER_IDS")
          throw new Error("Invalid event type");
        return t.providerIds;
      }
    }),
    changeProviderCount: o({
      selectedProviderCount: ({ event: t }) => {
        if (t.type !== "CHANGE_PROVIDER_COUNT")
          throw new Error("Invalid event type");
        return t.providerCount < 1 ? 1 : t.providerCount;
      }
    }),
    changeQuantity: o({
      quantity: ({ event: t }) => {
        if (t.type !== "CHANGE_QUANTITY")
          throw new Error("Invalid event type");
        return t.quantity < 1 ? 1 : t.quantity;
      }
    }),
    selectSlot: o({
      selectedSlot: ({ event: t }) => {
        if (t.type !== "SELECT_SLOT")
          throw new Error("Invalid event type");
        return t.slot;
      }
    }),
    selectSlotFrom: o({
      filterMaxSelectableTo: ({ event: t }) => {
        if (t.type !== "SELECT_SLOT_FROM")
          throw new Error("Invalid event type");
        return t.maxSelectableTo;
      },
      filterFrom: ({ event: t }) => {
        if (t.type !== "SELECT_SLOT_FROM")
          throw new Error("Invalid event type");
        return t.from;
      }
    }),
    setCustomerLocation: o({
      customerLocation: ({ event: t }) => {
        if (console.log("setCustomerLocation: Setting customer location", t), t.type !== "SET_LOCATION")
          throw new Error("Invalid event type");
        return t.location;
      }
    }),
    setAddons: o({
      addOns: ({ event: t }) => {
        if (t.type !== "SET_ADDONS")
          throw new Error("Invalid event type");
        return t.addOns;
      }
    }),
    setCustomFields: o({
      customFields: ({ event: t }) => {
        if (t.type !== "SET_CUSTOM_FIELDS")
          throw new Error("Invalid event type");
        return t.customFields;
      }
    }),
    emitReservationReadyEvent: n(() => ({
      type: s.RESERVATION_READY,
      data: null
    })),
    emitAvailabilitiesUpdated: n(({ context: t }) => ({
      type: s.AVAILABILITIES_UPDATED,
      data: { availabilities: t.availabilities }
    })),
    emitSlotSelected: n(({ context: t }) => {
      if (!t.selectedSlot)
        throw new Error(
          "Cannot emit slot selected event: No slot is selected"
        );
      return {
        type: s.SLOT_SELECTED,
        data: { slot: t.selectedSlot }
      };
    }),
    emitLocationSelected: n(({ context: t }) => {
      if (console.log("emitLocationSelected: Emitting location selected event"), !t.customerLocation)
        throw new Error(
          "Cannot emit customer location updated event: Customer location is not set yet"
        );
      return {
        type: s.CUSTOMER_LOCATION_UPDATED,
        data: { customerLocation: t.customerLocation }
      };
    }),
    emitCustomFieldsUpdated: n(({ context: t }) => {
      if (!t.customFields)
        throw new Error(
          "Cannot emit custom fields updated event: No custom fields set"
        );
      return {
        type: s.CUSTOM_FIELDS_UPDATED,
        data: { customFields: t.customFields }
      };
    }),
    emitProvidersUpdated: n(({ context: t }) => ({
      type: s.PROVIDERS_UPDATED,
      data: {
        providerIds: t.selectedProviderIds,
        providerCount: t.selectedProviderCount
      }
    })),
    emitMonthChanged: n(({ context: t }) => ({
      type: s.MONTH_CHANGED,
      data: {
        year: t.displayYear,
        month: t.displayMonth
      }
    })),
    emitPriceAmountUpdate: n(({ context: t }) => ({
      type: s.AMOUNTS_UPDATED,
      data: t.amount
    })),
    emitError: n(({ context: t }) => {
      if (!t.error)
        throw new Error("Cannot emit error event: No error is set");
      return {
        type: s.ERROR,
        data: t.error
      };
    })
  },
  guards: {
    isReservationProductSet: ({ context: t }) => !!t.product,
    isSlotSelected: ({ context: t }) => !!t.selectedSlot,
    hasNoPendingCustomFields: ({ context: t }) => {
      const { product: e } = t;
      return !e.isFullDayBooking && !e.isVariableDuration && e.customFields.length === 0 || !!t.customFields;
    },
    hasValidLocation: ({ context: t }) => !t.product.hasGeofencedProviders || t.product.hasGeofencedProviders && !!t.customerLocation,
    hasValidProviderIds: ({ context: t }) => {
      if (!t.product.enableCustomerToChooseProvider && !t.product.showProviderName || t.selectedProviderCount !== void 0 && t.selectedProviderCount > 1)
        return !0;
      if (t.selectedProviderIds && t.selectedProviderIds.length > 0) {
        if (t.selectedSlot) {
          const i = t.availabilities.slots.find(
            (a) => a.from.getTime() === t.selectedSlot?.from.getTime()
          );
          return !i || !i.availableProviderIds ? !1 : t.selectedProviderIds.every(
            (a) => i.availableProviderIds.includes(a)
          );
        }
        return !0;
      }
      return !1;
    },
    canRetry: ({ context: t }) => t.errorRetries < A
  }
}).createMachine({
  id: "ReservationMachine",
  initial: "initializing",
  context: ({ input: t }) => p(
    t.product,
    t.initialPriceId,
    t.customerLocation
  ),
  states: {
    initializing: {
      entry: "resetRetries",
      always: [
        {
          guard: "isReservationProductSet",
          target: "fetchingAvailabilities"
        },
        {
          target: "error",
          actions: o({
            error: () => new c(
              "Reservation product not set",
              l.GENERAL_ERROR
            )
          })
        }
      ]
    },
    fetchingAvailabilities: {
      tags: ["loading"],
      entry: "emitMonthChanged",
      invoke: {
        src: "fetchAvailabilities",
        input: ({ context: t }) => ({ context: t }),
        onDone: {
          target: "updatingAmounts",
          actions: [
            o({
              availabilities: ({ event: t }) => t.output,
              selectedSlot: ({ context: t, event: e }) => t.selectedSlot === void 0 ? void 0 : e.output.slots.some(
                (a) => a.from.getTime() === t.selectedSlot?.from.getTime() && a.to.getTime() === t.selectedSlot?.to.getTime()
              ) ? t.selectedSlot : void 0,
              filterMaxSelectableTo: ({ context: t, event: e }) => {
                if (t.filterFrom !== void 0)
                  return e.output.slots.find(
                    (i) => i.from.toISOString() === t.filterFrom.toISOString()
                  )?.maxConnectedTo;
              }
            }),
            { type: "emitAvailabilitiesUpdated" },
            { type: "resetRetries" }
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      },
      guards: u(["isSlotSelected", "hasValidProviderIds"])
    },
    updatingAmounts: {
      tags: ["loading"],
      invoke: {
        src: "updateAmounts",
        input: ({ context: t }) => ({ context: t }),
        onDone: {
          target: "idle",
          actions: [
            o({
              amount: ({ event: t }) => t.output
            }),
            { type: "emitPriceAmountUpdate" }
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    idle: {
      tags: ["idle"],
      on: {
        CHANGE_PRICE: {
          target: "fetchingAvailabilities",
          actions: "changePrice"
        },
        SELECT_SINGLE_DATE: {
          actions: [
            { type: "selectSingleDate" },
            { type: "emitSlotSelected" }
          ]
        },
        CHANGE_MONTH: {
          target: "fetchingAvailabilities",
          actions: "changeMonth"
        },
        CHANGE_PROVIDER_IDS: {
          target: "fetchingAvailabilities",
          actions: [
            { type: "changeProviderIds" },
            { type: "emitProvidersUpdated" }
          ]
        },
        CHANGE_PROVIDER_COUNT: {
          target: "fetchingAvailabilities",
          actions: [
            { type: "changeProviderCount" },
            { type: "emitProvidersUpdated" }
          ]
        },
        CHANGE_QUANTITY: {
          target: "fetchingAvailabilities",
          actions: "changeQuantity"
        },
        SELECT_SLOT: {
          actions: [{ type: "selectSlot" }, { type: "emitSlotSelected" }]
        },
        SELECT_SLOT_FROM: {
          actions: "selectSlotFrom"
        },
        SET_LOCATION: {
          target: "fetchingAvailabilities",
          actions: [
            { type: "setCustomerLocation" },
            { type: "emitLocationSelected" }
          ]
        },
        SET_ADDONS: {
          target: "updatingAmounts",
          actions: "setAddons"
        },
        SET_CUSTOM_FIELDS: {
          target: "updatingAmounts",
          actions: [
            { type: "setCustomFields" },
            { type: "emitCustomFieldsUpdated" }
          ]
        }
      },
      always: [
        {
          guard: u(["isSlotSelected", "hasValidProviderIds"])
        }
      ]
    },
    reservationReady: {
      on: {
        RESERVATION_READY: {
          target: "idle",
          actions: "resetContext"
        }
      }
    },
    error: {
      tags: ["error"],
      entry: ["incrementRetries", "emitError"],
      on: {
        RETRY: [
          {
            guard: "canRetry",
            target: "fetchingAvailabilities"
          },
          {
            target: "terminated"
          }
        ],
        RESET: {
          target: "initializing",
          actions: "resetContext"
        }
      }
    },
    terminated: {
      type: "final"
    }
  }
});
class g {
  machine = null;
  actor = null;
  /**
   * Creates a new ReservationStateMachine instance
   *
   * @param productQueryService - Service for product-related API operations
   */
  constructor(t) {
    this.machine = h(t);
  }
  /**
   * Returns the underlying machine instance
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  getInstance() {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.machine;
  }
  /**
   * Creates an actor instance if one doesn't exist
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  createActor(t) {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.actor || (this.actor = m(this.machine, { input: t })), this.actor;
  }
  /**
   * Gets the actor instance, starting it if necessary
   */
  getActor(t) {
    if (!this.actor && t)
      this.actor = this.createActor(t);
    else if (!this.actor)
      throw new Error("Actor not created and no input provided");
    return this.actor.getSnapshot().status !== "active" && this.actor.start(), this.actor;
  }
  /**
   * Gets the current state snapshot of the actor
   */
  getState() {
    return this.getActor().getSnapshot();
  }
  /**
   * Gets the current context of the state machine
   */
  getContext() {
    return this.getState().context;
  }
  /**
   * Sends an event to the state machine
   */
  send(t) {
    this.getActor().send(t);
  }
  /**
   * Checks if the state machine is in a loading state
   */
  isLoading() {
    return this.getState().tags.has("loading");
  }
  /**
   * Checks if the state machine is in an error state
   */
  isError() {
    return this.getState().tags.has("error");
  }
  /**
   * Checks if the state machine is in a processing state
   */
  isProcessing() {
    return this.getState().tags.has("processing");
  }
  /**
   * Gets the current error if the machine is in an error state
   */
  getError() {
    return this.getContext().error;
  }
  /**
   * Sends a retry event to recover from an error state
   */
  retry() {
    this.send({ type: "RETRY" });
  }
  /**
   * Sends a reset event to completely reset the machine
   */
  reset() {
    this.send({ type: "RESET" });
  }
  /**
   * Changes the price ID
   */
  changePrice(t) {
    this.send({ type: "CHANGE_PRICE", priceId: t });
  }
  /**
   * Selects a single date
   */
  selectDate(t) {
    this.send({ type: "SELECT_SINGLE_DATE", date: t });
  }
  /**
   * Changes the displayed month
   */
  changeMonth(t) {
    this.send({ type: "CHANGE_MONTH", date: t });
  }
  /**
   * Updates the selected provider IDs
   */
  changeProviderIds(t) {
    this.send({ type: "CHANGE_PROVIDER_IDS", providerIds: t });
  }
  /**
   * Updates the provider count
   */
  changeProviderCount(t) {
    this.send({ type: "CHANGE_PROVIDER_COUNT", providerCount: t });
  }
  /**
   * Updates the quantity
   */
  changeQuantity(t) {
    this.send({ type: "CHANGE_QUANTITY", quantity: t });
  }
  /**
   * Selects a time slot
   */
  selectSlot(t) {
    this.send({ type: "SELECT_SLOT", slot: t });
  }
  /**
   * Sets starting slot for variable duration
   */
  selectSlotFrom(t, e) {
    this.send({ type: "SELECT_SLOT_FROM", from: t, maxSelectableTo: e });
  }
  /**
   * Sets the add-ons for the reservation
   */
  setAddons(t) {
    this.send({ type: "SET_ADDONS", addOns: t });
  }
  /**
   * Sets the custom fields for the reservation
   */
  setCustomFields(t) {
    this.send({ type: "SET_CUSTOM_FIELDS", customFields: t });
  }
  /**
   * Sets the location
   */
  setLocation(t) {
    console.log("Setting location", t), this.send({ type: "SET_LOCATION", location: t });
  }
  /**
   * Stops the actor if it's running
   */
  stop() {
    this.actor && this.actor.stop();
  }
}
const v = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ReservationStateMachine: g,
  reservationMachine: h
}, Symbol.toStringTag, { value: "Module" }));
export {
  c as R,
  l as a,
  g as b,
  v as r
};
//# sourceMappingURL=reservation-machine-BrOyOFNE.js.map
